export enum CustomTags {
  CampaignUrl = "{{landing-page-url}}",
  PublisherUrl = "{{partner-url}}",
}
